import { tuiCreateToken } from '@taiga-ui/cdk';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE, WINDOW } from '@ng-web-apis/common';
import { BehaviorSubject } from 'rxjs';
const TUI_THEME_STORAGE_DEFAULT_KEY = `tuiTheme`;
const TUI_THEME_DEFAULT_NAME = `Taiga UI`;
const TUI_THEME_STORAGE_KEY = tuiCreateToken(TUI_THEME_STORAGE_DEFAULT_KEY);
const TUI_THEME_NAME = tuiCreateToken(TUI_THEME_DEFAULT_NAME);
let TuiThemeService = /*#__PURE__*/(() => {
  class TuiThemeService extends BehaviorSubject {
    constructor(initialTheme, key, storage) {
      super(storage.getItem(key) || initialTheme);
      this.initialTheme = initialTheme;
      this.key = key;
      this.storage = storage;
    }
    next(theme) {
      this.storage.setItem(this.key, theme);
      super.next(theme);
    }
    get isDefaultTheme() {
      return this.value === TUI_THEME_DEFAULT_NAME;
    }
  }
  TuiThemeService.ɵfac = function TuiThemeService_Factory(t) {
    return new (t || TuiThemeService)(i0.ɵɵinject(TUI_THEME_NAME), i0.ɵɵinject(TUI_THEME_STORAGE_KEY), i0.ɵɵinject(LOCAL_STORAGE));
  };
  TuiThemeService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TuiThemeService,
    factory: TuiThemeService.ɵfac,
    providedIn: `root`
  });
  return TuiThemeService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_THEME_NIGHT_STORAGE_DEFAULT_KEY = `tuiNight`;
const TUI_THEME_NIGHT_STORAGE_KEY = tuiCreateToken(TUI_THEME_NIGHT_STORAGE_DEFAULT_KEY);
const TUI_USE_DEFAULT_NIGHT_THEME = tuiCreateToken(true);
let TuiThemeNightService = /*#__PURE__*/(() => {
  class TuiThemeNightService extends BehaviorSubject {
    constructor(win, storage, key, useDefaultNightTheme) {
      super(storage.getItem(key) === `true` || storage.getItem(key) === null && win.matchMedia(`(prefers-color-scheme: dark)`).matches);
      this.win = win;
      this.storage = storage;
      this.key = key;
      this.useDefaultNightTheme = useDefaultNightTheme;
    }
    next(night) {
      this.storage.setItem(this.key, String(night));
      super.next(night);
    }
    toggle() {
      this.next(!this.value);
    }
  }
  TuiThemeNightService.ɵfac = function TuiThemeNightService_Factory(t) {
    return new (t || TuiThemeNightService)(i0.ɵɵinject(WINDOW), i0.ɵɵinject(LOCAL_STORAGE), i0.ɵɵinject(TUI_THEME_NIGHT_STORAGE_KEY), i0.ɵɵinject(TUI_USE_DEFAULT_NIGHT_THEME));
  };
  TuiThemeNightService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: TuiThemeNightService,
    factory: TuiThemeNightService.ɵfac,
    providedIn: `root`
  });
  return TuiThemeNightService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_THEME_DEFAULT_NAME, TUI_THEME_NAME, TUI_THEME_NIGHT_STORAGE_DEFAULT_KEY, TUI_THEME_NIGHT_STORAGE_KEY, TUI_THEME_STORAGE_DEFAULT_KEY, TUI_THEME_STORAGE_KEY, TUI_USE_DEFAULT_NIGHT_THEME, TuiThemeNightService, TuiThemeService };
